import Vue from 'vue';
import ApiUrl from '../apiurl';

export default {
    namespaced: true,
    state: {
        timelineList: [],
        priceladderList: [],
        priceskeletonList: [],
        dimensionList: [],
    },
    getters: {

        timelineList: (state) => {
            return state.timelineList;
        },
        priceladderList: (state) => {
            return state.priceladderList;
        },
        priceskeletonList: (state) => {
            return state.priceskeletonList;
        },
        dimensionList: (state) => {
            return state.dimensionList;
        }
    },
    mutations: {

        setDimensionList(state, newValue) {
            Vue.set(state, 'dimensionList', newValue);
        },
        setTimelineList(state, newValue) {
            Vue.set(state, 'timelineList', newValue);
        },
        setPriceladderList(state, newValue) {
            if (Array.isArray(newValue)) {
                Vue.set(state, 'priceladderList', [...newValue]);
            }
        },
        setPriceskeletonList(state, newValue) {
            if (Array.isArray(newValue)) {
                Vue.set(state, 'priceskeletonList', [...newValue]);
            }
        },
        clearDimensionList(state) {
            Vue.set(state, 'dimensionList', []);
        },

    },
    actions: {
        async queryDimensionList({ commit, state }, { params, handle }) {
            try {
                commit('startLoading', null, { root: true });
                const rsp = await axios.post(ApiUrl.depth.dimension, params);
                var list = rsp.data.result;

                commit('setDimensionList', list);
                handle && handle(true);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }
        },
        async queryTimelineList({ commit, state }, { params, handle }) {
            try {
                commit('startLoading', null, { root: true });
                const rsp = await axios.post(ApiUrl.depth.timeline, params);
                var list = rsp.data.result;
                commit('setTimelineList', list);
                handle && handle(true);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }
        },
        async queryPriceladderList({ commit, state }, { params, handle }) {
            try {
                commit('startLoading', null, { root: true });
                const rsp = await axios.post(ApiUrl.depth.priceladder, params);
                var list = rsp.data.result;
                commit('setPriceladderList', list);
                handle && handle(true);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }
        },
        async queryPriceskeletonList({ commit, state }, { params, handle }) {
            try {
                commit('startLoading', null, { root: true });
                const rsp = await axios.post(ApiUrl.depth.PriceSkeleton, params);
                var list = rsp.data.result;
                commit('setPriceskeletonList', list);
                handle && handle(true);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }
        },

    }
}